import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({ components: {} })
export default class SingleMainContainer extends Vue {
  @Prop() public title!: string;
  @Prop({ default: false }) public hideBackLink!: boolean;

  public goBack() {
    window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
  }
}
